<div class="dashletActivity">
  <img class="dashletActivities__icon--360-images" [src]="EIconPath.ACTIVITY_IMAGE_360_DARK" />

  <div class="dashletActivity__text">
    {{ isAdd ? ('added' | ppTranslate) : ('removed' | ppTranslate) }}
    <span class="timeline__strong">{{ numberOfChanges }}</span>
    {{ numberOfChanges > 1 ? ('images_360' | ppTranslate) : ('image_360' | ppTranslate) }}.
  </div>
</div>
